<!--  -->
<template>
<div class='container'>
    <div class="back" @click="$router.go(-1)"><img src="@/assets/img/back-ico.png" alt=""></div>
    <div class="name">{{photo.name}}</div>
    <div class="imageList">
        <swiper :options="swiperOptions" class="swiperContainer" ref="swiper" v-if="photo.imgs>1">
                <swiperSlide class="slide" v-for="(item,i) in photo.imgs" :key="i"><div class="item"><img v-viewer="{title:false,navbar:false,toolbar:false}" :src="`${$baseUrl}/static/${photo.authorId}/${photo.id}/${item}.JPG`" alt=""></div></swiperSlide>                 
                    <div class="btn swiper-button-prev" slot="button-prev"></div>
                    <div class="btn swiper-button-next" slot="button-next"></div>                              
            </swiper>
            <div class="swiperContainer" v-else>
                <div class="slide" v-for="(item,i) in photo.imgs" :key="i">
                    <div class="item"><img v-viewer="{title:false,navbar:false,toolbar:false}" :src="`${$baseUrl}/static/${photo.authorId}/${photo.id}/${item}.JPG`" alt=""></div>
                </div>
            </div>
    </div>
    <div class="infoContent">
        <div class="share" @click="isShare=!isShare"><img src="@/assets/img/share3.png" alt=""></div>
        <div class="date"><i></i>年代：{{photo.date}}</div>
        <!-- <div class="size"><i></i>尺寸：{{photo.size}}</div> -->
        <div class="content">
            <p v-for="(item,i) in photo.info" :key="i">{{item}}</p>
        </div>
    </div>
    <poster v-if="isShare" @close="isShare=!isShare"></poster>
</div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import poster from "../../components/poster.vue"
export default {
//import引入的组件需要注入到对象中才能使用
components: {
    swiper,
    swiperSlide,
    poster    
},
data() {
//这里存放数据
return {
    isShare:false,
    swiperOptions:{
         navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          }
    },
    photo:{
    },
    photos:[
        {
            id:0,
            authorId:1,
            name:'九成宫醴泉铭碑',
            imgs:2,
            date:'唐贞观六年（632年）',
            size:'96*166',
            info:['《九成宫醴泉铭》由魏征撰文、欧阳询书而成，原碑刻于贞观六年（632年），现存于陕西麟游县碑亭景区。《九成宫醴泉铭》叙述了“九成宫”的来历和其建筑的雄伟壮观，歌颂了唐太宗的武功文治和节俭精神，介绍了宫城内发现醴泉的经过，并刊引典籍说明醴泉的出现是由于“天子令德”所致，最后提出“居高思坠，持满戒盈”的谏诤之言。《九成宫醴泉铭》结体修长，中宫收紧，四边开张，左敛右纵，化险为夷。字形随势赋形，左右结构作相背之势，上下结构上窄下宽，间架开阔稳定，气象庄严。其布白匀整，字距、行距疏朗。全碑血脉畅通，气韵萧然。《九成宫醴泉铭》是欧阳询晚年经意之作，历来为学书者推崇，视为楷书正宗，被后世誉为“天下第一楷书”。']

        },
        {
            id:1,
            authorId:1,
            name:'虞恭公温彦博碑',
            imgs:1,
            date:'唐',
            size:'',
            info: ['《虞恭公温彦博碑》，全称《唐故特进尚书右仆射上柱国虞恭公温公碑》，由岑文本撰文，欧阳询书，原碑刻于贞观十一年（637年），为陕西唐太宗昭陵陪葬碑之一。温彦博，初唐宰相，唐太宗即位时，出任中书令，进封虞国公，迁右仆射。贞观十一年（637年），病逝，享年六十四岁，获赠特进，谥号为恭，陪葬于昭陵。此碑楷法为欧体集大成者，其点画以方笔为主，铁画银钩，刚劲不挠；其结体险峻严密，横势用仰，纵势用背，比较其他各碑，却又平和稳实。']
        },
         {
            id:2,
            authorId:1,
            name:'皇甫诞碑',
            imgs:1,
            date:'唐',
            size:'',
            info: ['《皇甫诞碑》，全称《隋柱国左光禄大夫弘义明公皇甫府君之碑》，由于志宁撰，欧阳询书。此碑无明确立碑年月，推测立于於贞观十七年（643年），也有一说立于欧阳询早年时期。原碑在明代因地震断缺，现存西安碑林。《皇甫诞碑》是皇甫诞的儿子皇甫无逸邀书法大家欧阳询书写而刻成的，以纪念其父皇甫诞。此碑用笔紧密内敛，刚劲不挠，点画重在提笔刻入，此为唐初未脱魏碑及隋碑的瘦劲书风所特有的笔法特点。']
        },
         {
            id:3,
            authorId:1,
            name:'房彦谦碑',
            imgs:1,
            date:'唐',
            size:'',
            info: ['《房彦谦碑》，全碑称《唐故都督徐州五州诸军事徐州剌史临淄定公房公碑》，由李百药撰文，欧阳询书，原碑刻于贞观五年（631年），现存于山东济南房彦谦墓。房彦谦是唐贞观年间宰相房玄龄之父，碑文主要内容是褒扬房彦谦家世、履历及其为人的高风亮节。']
        },
        {
            id:0,
            authorId:2,
            name:'多宝塔碑',
            imgs:2,
            date:'唐',
            size:'',
            info:['《多宝塔碑》，全称为《大唐西京千福寺多宝佛塔感应碑》，由岑勋撰文、徐浩题额、颜真卿书，原碑刻于天宝十一年（752年），现存于西安碑林。该碑内容主要记载了西京龙兴寺禅师楚金创建多宝塔之原委及修建经过。整体秀美刚劲，清爽宜人，有简洁明快，字字珠玑之感。用笔丰厚遒美，腴润沉稳；横细竖粗，对比强烈；起笔多露锋，收笔多回锋，转折多顿笔。结体严谨致密，紧凑规整，平稳匀称，又碑版精良，存字较多，学颜体者多从此碑下手，入其堂奥。']
        },
         {
            id:1,
            authorId:2,
            name:'东方朔画赞碑',
            imgs:3,
            date:'唐',
            size:'',
            info:['《东方朔画赞碑》，全称《汉太中大夫东方先生画赞碑》，由晋代夏侯湛撰，颜真卿书，原碑刻于天宝十三年（754年），现存于山东德州。天宝十三年（754年），颜真卿出守平原（今山东德州），颜真卿游览当地的东方朔神庙，见其碑文磨损不堪，感叹之余，挥毫依旧文重书，复刊于石。颜真卿书此碑时正值盛年，笔法刚健雄浑，遒劲严正。苏轼评其碑：“颜鲁公平生写碑，唯东方朔画赞为清雄，字间栉比而不失清远。”']
        },
         {
            id:2,
            authorId:2,
            name:'臧怀恪碑',
            imgs:2,
            date:'唐',
            size:'',
            info:['《臧怀恪碑》，全称《唐故右武卫将军赠工部尚书上柱国上蔡县开国侯臧公神道碑铭并序》，由颜真卿撰文并书，原碑刻于广德元年（763年），现存于西安碑林。碑文内容记述臧怀恪的籍贯、家世和战功。此碑结体宽博疏朗，疏秀雄健，浑厚圆劲，比《多宝塔感应碑》更为宽博，也不像晚年所书的《颜氏家庙碑》凝重雄浑，而以“秀润劲健”的书风面目出现，不同于颜真卿其他碑中的庙堂之气，而是具有书卷之气。']
        },
         {
            id:3,
            authorId:2,
            name:'郭氏家庙碑',
            imgs:1,
            date:'唐',
            size:'',
            info:['《郭氏家庙碑》，全称《有唐故中大夫使节寿州诸军事寿州刺史上柱国赠太保郭公庙铭并序》，由颜真卿撰文并书，原碑刻于广德二年（764年），唐代宗李豫隶书题额，现存于西安碑林。《郭氏家庙碑》系郭子仪为其父郭敬之建立家庙，叙述了郭子仪的家世及武功业绩。《郭氏家庙碑》属颜真卿晚年之作，笔力雄健，结构紧密，为颜真卿书碑中最完好者。']
        },
         {
            id:4,
            authorId:2,
            name:'元结碑',
            imgs:3,
            date:'唐',
            size:'',
            info:['《元结碑》，全称《唐故容州都督兼御史中丞本管经略使元君表墓碑铭并序》，由颜真卿撰并书，原碑刻于大历七年（772年），现存于河南鲁山。碑文记述了元结的世系、生平事迹及死葬年月，多处表达了颜真卿对元结的敬慕之情。此碑字迹浑厚雄健，遒劲秀挺，气势磅礴，满溢宁折不弯的浩然之气，是颜体的代表作品之一。']
        },
         {
            id:5,
            authorId:2,
            name:'八关斋会报德记碑',
            imgs:8,
            date:'唐',
            size:'',
            info:['《八关斋会报德记》，全称《有唐宋州官吏八关斋会报德记》，由颜真卿撰书，原碑刻于唐大历七年（772年），原石幢被毁，后复刻于商丘八关斋景区。大历七年四月，在安史之乱中解睢阳之围的将领田神功得热疾，睢阳百姓自发请僧人举行八关斋会为田神功祈福，以报其解救睢阳危难的恩德。为记录这次活动，颜真卿应邀而来，撰文并亲笔书写了此记。此记字大如拳，超过颜真卿其它书作字体规格，用笔方圆兼具，用锋藏露随心，结字宽博方正，其上下结构的字往往上疏下密，上大下小，有泰山压顶之势，通篇圆润不失劲健，浑厚内藏刚猛，为颜书大字佳作。']
        },
         {
            id:6,
            authorId:2,
            name:'干禄字书',
            imgs:2,
            date:'唐',
            size:'',
            info:['《干禄字书》，由颜元孙撰，后为颜真卿书写刻石，原碑刻于大历九年（774年），原碑已失，是唐代正字学的一项成果。正字学的主要内容，就是整理和研究异体字，确定文字的标准形体，促进文字的统一。颜元孙撰写的正字书《干禄字书》，后来颜真卿又将它书写刻石。由于它在文字学上和书法上的价值，受到人们重视，成为唐代石刻中的一件珍品。']
        },
         {
            id:7,
            authorId:2,
            name:'颜勤礼碑',
            imgs:3,
            date:'唐',
            size:'',
            info:['《颜勤礼碑》，全称《唐故秘书省著作郎夔州都督府长史护军颜君神道碑》，由颜真卿书，原碑刻于大历十四年（779年），现存于西安碑林。该碑是颜真卿为其曾祖父颜勤礼撰文并书写的神道碑，碑文追述颜氏祖辈功德，叙述后世子孙在唐王朝的业绩。《颜勤礼碑》是颜真卿晚年所书，其书法艺术已臻成熟之境，是“颜体”中的代表作。']
        },
         {
            id:8,
            authorId:2,
            name:'颜氏家庙碑',
            imgs:4,
            date:'唐',
            size:'',
            info:['《颜氏家庙碑》，全称为《唐故通议大夫行薛王右柱国赠秘书少监国子祭酒太子少保颜君庙碑铭并序》，由颜真卿书，原碑刻于建中元年（780年），现存于西安碑林。此碑是颜真卿为其父颜惟贞所立，记载家族世系情况。']
        },
        {
            id:9,
            authorId:2,
            name:'争座位帖',
            imgs:1,
            date:'唐',
            size:'',
            info: ['《争座位帖》，又名《论座帖》、《争座位稿》、《与郭仆射书》，颜真卿撰书，原迹已佚，刻石存西安碑林。该书贴为广德二年（764年），颜真卿致尚书右仆射、定襄郡王郭英乂的信函。颜真卿在信中直指郭英乂于安福寺兴道会上藐视礼仪，谄媚宦官鱼朝恩，致其礼遇高于六部尚书之事，字里行间洋溢着忠义之气。此贴有夹行小注和勾改痕迹，随意自如，挥洒有度，是颜真卿行草书法的代表作。']
        },
         {
            id:0,
            authorId:3,
            name:'冯宿碑',
            imgs:1,
            date:'唐',
            size:'',
            info:['《冯宿碑》，全称为《大唐故银青光禄大夫检校礼部尚书使持节梓州诸军事兼梓州刺史御史大夫充剑南东川节度副大使知节度事管内观察处置静戎军等使上柱国长乐县开国公食邑一千五百户赠吏部尚书冯公神道碑铭》，由王起撰，柳公权书，原碑刻于开成二年（837年），现存西安碑林。冯宿，唐末大臣，此碑记录其生平事迹。']
        },
         {
            id:1,
            authorId:3,
            name:'符璘碑',
            imgs:1,
            date:'唐',
            size:'',
            info:['《符璘碑》，全称《唐故辅国大将军行左神策军将军知军事检校右散骑常侍兼御史大夫义阳郡王食实封二百户赠越州都督刑部尚书符公神道碑铭并序》，此碑由李宗闵撰文，柳公权书，原碑刻于唐开成三年（838年），现已毁。符璘，唐朝将领，早年讨伐李怀光叛乱，抵抗吐蕃入寇，颇有功绩。后左神策军大将军，护卫皇城十三年，忠勤谨重。此碑历代享有盛名，书法上魄力雄浑，字法深厚，结构缜密，神理骏发。']
        },
         {
            id:2,
            authorId:3,
            name:'玄秘塔碑',
            imgs:2,
            date:'唐',
            size:'',
            info:['《玄秘塔碑》，全称《唐故左街僧录内供奉三教谈论引驾大德安国寺上座赐紫大达法师玄秘塔碑铭并序》，由时任宰相的裴休撰文，柳公权书，原碑刻于唐会昌元年（841年），现存于西安碑林。《玄秘塔碑》叙大达法师在德宗、顺宗、宪宗三朝所受恩遇，以纪念大达法师之事迹而告示后人。其书法结体紧密，笔法锐利，筋骨外露，阳刚十足，字迹如刀刻一般，且笔画粗细变化多端。《玄秘塔碑》为柳公权书法创作生涯中的一座里程碑，标志着“柳体”书法的完全成熟，历来被作为初学书法者的正宗范本，对后世影响深远。']
        },
         {
            id:3,
            authorId:3,
            name:'魏公先庙碑',
            imgs:1,
            date:'唐',
            size:'',
            info:['《魏公先庙碑》，崔玙撰，柳公权书，原碑刻于唐大中六年（852年），现已失。此碑为唐初名臣魏徵五世孙魏谟所立。魏徵于贞观初立家庙于长安城昌乐里，后魏谟拜相，翻修家庙，立碑为记。此碑笔轻灵活脱，稳中寓奇，其钩法、捺法、笔画的粗细已不刻意采取强烈的夸张对比，完全以意为之，轻松自如，臻于化境。']
        },
         {
            id:4,
            authorId:3,
            name:'高元裕碑',
            imgs:1,
            date:'唐',
            size:'',
            info:['《高元裕碑》，全称《大唐故吏部尚书赠尚书右仆射渤海高公神道碑》，由萧邺撰文，柳公权书，原碑刻于大中七年（853年），现已失。高元裕为唐后期大臣，康有为评此碑有“龙跳虎卧之气。”']
        },
         {
            id:5,
            authorId:3,
            name:'沂州普照寺碑',
            imgs:1,
            date:'金',
            size:'',
            info:['《沂州普照寺碑》，由仲汝尚撰，原碑刻于皇统四年（1144年），原碑已毁。金皇统四年（1144年），山东沂州（今山东临沂）普照禅寺主事妙济禅师对寺院进行扩建和修缮，一面请仲汝尚撰写《沂州普照禅寺兴造记》的碑文，一面奔波集唐著名书法家柳公权的墨迹，最后精刻于石上，此碑亦称为“集柳碑”。']
        },
        
        {
            id:0,
            authorId:4,
            name:'赵书狄梁公碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《赵书狄梁公碑》，由宋范仲淹撰，元赵孟頫书，原碑刻于大德四年（1300年）。狄梁公，即狄仁杰，唐代著名大臣，封梁国公。《狄梁公碑》是宋代宝元元年（1038年），范仲淹被贬，在去润州的路上，途经彭泽拜祭狄梁公祠，被狄梁公功德所感动而书写。碑文盛赞了狄梁公一生功绩，也抒发了自己报效国家、报效民众的思想感情。《赵书狄梁公碑》是赵孟頫于大德四年（1300年）重书的碑文，碑文笔法温润凝练，结体端丽严谨，气韵洒脱遒劲，形神疏放飘逸。碑帖展示了狄仁杰尽忠报国的高风亮节，范仲淹效贤为民的情怀文采，赵孟頫洒脱神韵的精湛书艺，堪称“三绝”。']
        },
        {
            id:1,
            authorId:4,
            name:'渔庄记碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《渔庄记》，由陈俨撰，赵孟頫书，原碑刻于大德十年（1306年），现存于新乡市博物馆。此碑是赵孟頫于元成宗大德十年（1306年）所写，这是他在书法艺术上更加成熟的年代，用笔园转流美，字体骨力劲秀。']
        },
        {
            id:2,
            authorId:4,
            name:'虎丘隆禅师碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《虎丘隆禅师碑》，由宋徐林撰，元赵孟頫书，原碑刻于至大三年（1310年），现已毁。碑文记载宋代绍隆禅师与其师圆悟禅师的故事。绍隆禅师与其师圆悟禅师在虎丘云岩禅寺将临济宗推向极盛，远传日本。绍隆禅师圆寂后，僧徒建塔于虎丘之东山庙。宋左朝奉郎守、司农少卿徐林撰碑文，后被毁。元代赵孟頫重书碑文，一气呵成，书风秀美，朗俊飘逸，丰神异秀。']
        },
        {
            id:3,
            authorId:4,
            name:'金刚经碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《金刚经碑》，由赵孟頫书，原碑刻于至大四年（1311年）。赵孟頫幼习书画，笃信佛法，曾手书《金刚经》数十卷，赠名山寺，《金刚般若波罗蜜经》通篇字体秀丽，平和简静，清劲拨俗。《金刚般若波罗蜜经》也是赵孟頫的代表作之⼀，笔法精妙，结字秀美，可⻅其书法审美，值得后世尊敬。']
        },
        {
            id:4,
            authorId:4,
            name:'投龙简记碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《投龙简记碑》，由赵孟頫书，原碑刻于延佑元年（1314年），现存于河南济源济渎庙。碑文记述元仁宗刚刚登基，派钦差大臣周应极等人，捧黄金龙、玉符简，到济渎庙祭祀济水，到王屋山祭祀山神的过程。整篇碑⽂的字体基本上是楷书，其间加杂着有⾏书的写法，在提笔运笔处⼜多了⼏分痛快潇洒的感觉，有着⼀种不拘⼀格、放浪不羁的韵味。']
        },
        {
            id:5,
            authorId:4,
            name:'大元敕藏御服之碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《大元敕藏御服之碑》，由赵世延撰，赵孟頫书，原碑刻于延祐二年（1315年），现存于陕西西安重阳宫。碑文记元成宗感异梦而赐御服于孙真人之事。此碑书法秀媚爽朗、灵动自然。']
        },
        {
            id:6,
            authorId:4,
            name:'寿春堂记碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《寿春堂记碑》，由赵孟頫书，原碑刻于延祐三年（1316年）。《寿春堂记碑》在书法上是融合二王、李邕而又出以劲肆之作，方正谨严，纵横疾速，潇洒隽秀，劲健遒媚。']
        },
        {
            id:7,
            authorId:4,
            name:'李彬碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《李彬碑》，全称《追封陇西郡伯李彬碑》，由元明善撰，赵孟頫书，原碑刻于延祐五年（1318年），现存于许昌关帝庙。碑文记录了朝廷官员李谦恭请朝廷追封其父李彬为陇西郡伯的相关情况。']
        },
        {
            id:8,
            authorId:4,
            name:'长明灯记碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《长明灯记碑》，由揭奚斯撰，赵孟頫书，原碑刻于延佑七年（1320年），现存于河南延津大觉寺。此碑主要介绍泰安王子（也先帖木儿）野仙帖穆而为大觉寺捐田一千五百亩，作为供奉长明灯之资，和其一生报国功德向长明灯一样，永照后世的事迹。此碑其字外貌圆润而筋骨内涵，点画华滋遒劲，结体宽绰秀美，楷中略掺行书笔法。但碑面漫漶严重，许多笔画已不清晰，甚为可惜。']
        },
        {
            id:9,
            authorId:4,
            name:'辉州重修玉虚观碑',
            imgs:1,
            date:'元',
            size:'',
            info:['《辉州重修玉虚观碑》，由王恽撰，赵孟頫书，原碑刻于至元元年（1335年），现存于河南辉县百泉。此碑记载辉县玉虚观入元之后，屡经修葺，渐为名观之记过。碑⽂字体柔中有刚，圆润骏逸，为书法之精品。']
        },
    ]
};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {
    console.log(this.$route.query.m,this.$route.query.id)
    this.photo = this.photos.filter((item,i)=>{
        return item.id==this.$route.query.id&&item.authorId==this.$route.query.m
    })[0]
},
beforeCreate() {}, //生命周期 - 创建之前
beforeMount() {}, //生命周期 - 挂载之前
beforeUpdate() {}, //生命周期 - 更新之前
updated() {}, //生命周期 - 更新之后
beforeDestroy() {}, //生命周期 - 销毁之前
destroyed() {}, //生命周期 - 销毁完成
activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang='css' scoped>
    .container {
        width:100%;
        height:228.2vw;
        background:url(../../assets/img/bg-3.jpg)center/100% no-repeat;
        background-attachment: fixed;
        overflow:hidden;
    }
    .back {
        position:absolute;
        width:12.8vw;
        top:0;
        left:2vw;
    }
    .name {
        text-align:center;
         font-family: "SUXINSHIGUYINSONGJIAN-1";
         color:#0e0906;
         font-size:4.8vw;
         font-weight: bold;
         margin:13vw auto;
    }
    .imageList {
        width:100%;
        height:80vw;
        margin:0 auto 10vw;
    }
    .infoContent {
        position:relative;
        color:#0e0906;
        font-size:3.7vw;
        font-family: "simkai";
    }
    .infoContent .share {
        position:absolute;
        width:12.2vw;
        right:9vw;
        top:-5vw;
    }
    .infoContent .content {
        width:77vw;
        margin:5vw auto 0;
    }
    .infoContent .size,.infoContent .date {
        margin-left:9vw;
        height:4vw;
        line-height:4vw;
        margin-bottom:2vw;
    }
    .infoContent .size i,.infoContent .date i {
        display:inline-block;
        width:3.3vw;
        height:4vw;
        background:url(../../assets/img/ico3.png)center/3.3vw 3.3vw no-repeat;
        vertical-align: top;
        margin-right:1vw;
    }
    .infoContent .content p {
        text-indent:2em;
        margin-bottom:2vw;
        text-align: justify;
    }

    .swiperContainer {
        position:relative;
        width:100%;
        height:100%;        
    }
    .swiperContainer .slide {
        width:100%;
        height:100%;
    }
    .swiperContainer .item {
        position:relative;
        width:100%;
        height:100%;
        display:flex;
        justify-content: center;
        align-items:center;
    }
    .swiperContainer .item  img{
        max-width:100%;
        max-height:100%;
        -webkit-touch-callout:none;
        -webkit-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
    }
    .swiperContainer .btn {
        width:7.7vw;
        height:7.7vw;
        background:url(../../assets/img/prev.png)center/100% no-repeat;
    }
    .swiperContainer .btn.swiper-button-next {
        transform:rotate(180deg)
    }
</style>


// WEBPACK FOOTER //
// src/pages/photo/index.vue